import "babel-polyfill";
import Vue from "vue";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import headful from "vue-headful";
import DatePicker from "vue2-datepicker";
import VeeValidate from "vee-validate";
import router from "@/router";
// import VueScrollTo from "vue-scrollto";
import device from "current-device";
import moment from "moment";
import Axios from "axios";
import store from "@/store";
import "./plugins/Glider/js/glider.min.js";
import App from "./App.vue";

import "./assets/styles/styles.less";
// import 'vue-range-slider/dist/vue-range-slider.css';

var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

Vue.use(VueRouter);
Vue.use(VueResource);
// Vue.use(VueScrollTo);
Vue.use(VeeValidate);
Vue.use(DatePicker);

import Meta from 'vue-meta';
Vue.use(Meta);

// Global components
import IconsSVG from "@/components/svg/icons.vue";

Vue.component('IconsSVG', IconsSVG);

require("./core");
require("./plugins");

Vue.component("vue-headful", headful);

Vue.prototype.$device = device;


moment.updateLocale('en', {
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember']
});
Vue.prototype.moment = moment;

const app = new Vue({
    store,
    router,
    Axios,
    render: h => h(App),
    mounted() {
        setTimeout(()=>{
            let event = new Event('renderer-ready')
            window.document.dispatchEvent(event)
        },10000)
    }
}).$mount("#app");